import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccountIndexComponent } from './index';
import { CanActivateGuard } from './../shared/index';

export const AccountRoutes: Routes = [
    {
        path: 'account',
        component: AccountIndexComponent,
        canActivate: [CanActivateGuard]
    }
];

export const AccountRouting: ModuleWithProviders<RouterModule> = RouterModule.forChild(AccountRoutes);
